class CommandParser {
    constructor() {
      this.commands = {};
      this.commandInfo = {};
      this.error = null;
    }
  
    registerCommand(commandName, handler, info) {
      this.commands[commandName] = handler;
      this.commandInfo[commandName] = {
        name: commandName,
        description: info.description || '',
        args: info.args || [],
        examples: info.examples || []
      };
    }
  
    parse(input) {
      this.error = null;
      const parts = input.split(' ');
      const command = parts[0].slice(1); // Remove the leading '/'
      const args = parts.slice(1);
  
      if (!this.isCommandRegistered(input)) {
        this.error = `Unknown command: ${command}`;
        return null;
      }
  
      const positionalArgs = [];
      const keyValueArgs = {};
  
      for (const arg of args) {
        if (arg.includes(':')) {
          const [key, value] = arg.split(':');
          keyValueArgs[key] = this.parseValue(value);
        } else {
          positionalArgs.push(this.parseValue(arg));
        }
      }
  
      try {
        return this.commands[command](positionalArgs, keyValueArgs);
      } catch (err) {
        this.error = err.message;
        return null;
      }
    }
  
    parseValue(value) {
      if (value.toLowerCase() === 'true') return true;
      if (value.toLowerCase() === 'false') return false;
      if (!isNaN(value)) return Number(value);
      return value;
    }
  
    getLastError() {
      return this.error;
    }
  
    isCommandRegistered(input) {
      if (typeof input !== 'string' || !input.startsWith('/')) {
        return false;
      }
      const command = input.split(' ')[0].slice(1);
      return Object.prototype.hasOwnProperty.call(this.commands, command);
    }
  
    getRegisteredCommands() {
      return Object.values(this.commandInfo);
    }
  
    getRegisteredCommandsHTML() {
        const style = `
          <style>
            .command-list { font-family: Arial, sans-serif; max-width: 800px; margin: 0 auto; color: #333; }
            .command { background-color: #f0f0f0; border-radius: 5px; padding: 10px; margin-bottom: 10px; }
            .command-name { font-weight: bold; color: #000; }
            .command-description { color: #333; margin: 5px 0; }
            .args-list { list-style-type: none; padding-left: 0; }
            .arg { margin-bottom: 5px; }
            .arg-name { font-weight: bold; color: #0066cc; }
            .arg-type { color: #006600; }
            .arg-description { color: #333; }
            .examples { margin-top: 10px; }
            .example { font-family: monospace; background-color: #e0e0e0; padding: 2px 5px; border-radius: 3px; color: #000; }
          </style>
        `;
    
        const commandsHTML = this.getRegisteredCommands().map(cmd => `
          <div class="command">
            <div class="command-name">/${cmd.name}</div>
            <div class="command-description">${cmd.description}</div>
            <div>Arguments:</div>
            <ul class="args-list">
              ${cmd.args.map(arg => `
                <li class="arg">
                  <span class="arg-name">${arg.name}</span>
                  <span class="arg-type">(${arg.type}${arg.optional ? ', optional' : ''})</span>:
                  <span class="arg-description">${arg.description}</span>
                </li>
              `).join('')}
            </ul>
            <div class="examples">
              Examples:
              ${cmd.examples.map(ex => `<div class="example">${ex}</div>`).join('')}
            </div>
          </div>
        `).join('');
    
        return `
          <div class="command-list">
            ${style}
            <h2>Registered Commands</h2>
            ${commandsHTML}
          </div>
        `;
      }
    }
  

  export default CommandParser;